import * as React from "react";
import { dialogBoxSx, Message } from "./styles";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom";
import paths from "../../../Infrastructure/Router/paths";

export default function DialogBox({ open, setOpen, message, coursesPage }) {
  const theme = useTheme();
  const navigate= useNavigate()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClose = () => {
    setOpen(false);
  };
  const navigateToDashboard = () => {
    setOpen(false);
    if (!coursesPage) {
      navigate(paths.dashboardPage.path);
    }
  };
  return (
    <Modal
      open={open}
      disableScrollLock
      onClose={handleClose}
      aria-labelledby="responsive-modal-title"
    >
      <Box
        sx={{...dialogBoxSx.container, width: fullScreen ? '90%' : 400,}}
      >
        <Message variant="body2">
          {message}
        </Message>
        <Button
          onClick={navigateToDashboard}
          variant="contained"
          sx={{ ...dialogBoxSx.button }}
          fullWidth
        >
          {coursesPage ? "Close" : "Dashboard"}
        </Button>
      </Box>
    </Modal>
  );
}
